/* eslint-disable react/prop-types */
/**
 * Copyright © Scandiweb, Inc. All rights reserved.
 *
 * @category    Puma
 * @package     Puma_Tamara
 * @author      Beshoy Samuel <info@scandiweb.com>
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import TamaraQuery from 'Query/Tamara.query';
import { PriceType } from 'Type/Price.type';
import {
    calculateFinalPrice,
    roundPrice
} from 'Util/Price';
import { fetchQuery } from 'Util/Request/Query';

import TamaraPdpComponent from './TamaraPdp.component';

/** @namespace Scandipwa/Component/TamaraPdp/Container */
export class TamaraPdpContainer extends PureComponent {
    state = {
        public_key: null,
        currency_code: null,
        country_code: null,
        payment_method: null,
        error: null,
        isLoading: true
    };

    static propTypes = {
        price: PriceType,
        order: PropTypes.number
    };

    static defaultProps = {
        price: {},
        order: 0
    };

    componentDidMount() {
        const {
            tamaraWidgetPdp: {
                script_url = '',
                public_key = '',
                currency_code = '',
                country_code = '',
                payment_method = {},
                error = ''
            } = {}
        } = this.props;

        if (window.TamaraWidgetV2) {
            this.setState({ isLoading: false, error: false });

            return;
        }

        if (script_url === '') {
            fetchQuery(TamaraQuery.getWidgetPdp()).then(
                /** @namespace Scandipwa/Component/TamaraPdp/Container/TamaraPdpContainer/componentDidMount/then/catch/fetchQuery/then */
                ({ getTamaraWidgetPdp }) => {
                    const {
                        script_url, public_key, currency_code, country_code, payment_method, error
                    } = getTamaraWidgetPdp;

                    const script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.text = `(function(a,b,c,d){
                            a='${script_url}';
                            b=document;c='script';d=b.createElement(c);d.src=a;
                            d.type='text/java'+c;d.async=true;
                            d.id='tamarapdpwidget';
                            a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a)
                        })()`;

                    document.head.insertBefore(script, document.head.childNodes[0]);

                    window.tamaraWidgetConfig = {
                        lang: this.isArabicCacheWorkaround() ? 'ar' : 'en',
                        country: country_code,
                        publicKey: public_key,
                        css: `
                            .tamara-summary-widget__container {
                              --font-primary: var(--font-FFDIN),DroidKufi_Regular,Arial;,sans-serif;
                              --font-secondary: var(--font-FFDIN),DroidKufi_Regular,Arial;,sans-serif;
                            }
                          `
                    };

                    this.setState({
                        public_key,
                        currency_code,
                        country_code,
                        payment_method,
                        error,
                        isLoading: false
                    });
                }
            ).catch(
                /** @namespace Scandipwa/Component/TamaraPdp/Container/TamaraPdpContainer/componentDidMount/then/catch */
                () => {
                    this.setState({ isLoading: false, error: true });
                }
            );
        } else {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.text = `(function(a,b,c,d){
                    a='${script_url}';
                    b=document;c='script';d=b.createElement(c);d.src=a;
                    d.type='text/java'+c;d.async=true;
                    d.id='tamarapdpwidget';
                    a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a)
                })()`;

            document.head.insertBefore(script, document.head.childNodes[0]);

            window.tamaraWidgetConfig = {
                lang: this.isArabicCacheWorkaround() ? 'ar' : 'en',
                country: country_code,
                publicKey: public_key,
                css: `
                    .tamara-summary-widget__container {
                        --font-primary: var(--font-FFDIN),DroidKufi_Regular,Arial;,sans-serif;
                        --font-secondary: var(--font-FFDIN),DroidKufi_Regular,Arial;,sans-serif;
                    }
                `
            };

            this.setState({
                public_key,
                currency_code,
                country_code,
                payment_method,
                error,
                isLoading: false
            });
        }
    }

    isArabicCacheWorkaround() {
        const doc = document.documentElement;

        if (doc) {
            return doc.getAttribute('dir') === 'rtl';
        }

        return false;
    }

    containerProps = () => {
        const { price, order } = this.props;
        if (!price) {
            return {};
        }

        const {
            price: {
                minimum_price: {
                    discount: {
                        percent_off: discountPercentage
                    } = {},
                    final_price: {
                        value: minimalPriceValue
                    } = {},
                    regular_price: {
                        value: regularPriceValue
                    } = {}
                } = {}
            } = {}
        } = this.props;

        if (!minimalPriceValue || !regularPriceValue) {
            return {};
        }

        const finalPrice = calculateFinalPrice(discountPercentage, minimalPriceValue, regularPriceValue);
        const formatedPrice = roundPrice(finalPrice);

        const {
            public_key, currency_code, country_code, payment_method, error, isLoading
        } = this.state;

        return {
            public_key,
            formatedPrice,
            order,
            currency_code,
            country_code,
            payment_method,
            error,
            isLoading
        };
    };

    render() {
        return (
            <TamaraPdpComponent
              { ...this.containerProps() }
            />
        );
    }
}

export default TamaraPdpContainer;
